export enum IDTypeRequest {
  Scritta = '3',
  Verbale = '4',
}
